import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useRequest, type MutationFunction } from '../common';
import { getManagedIntegrationListKey } from './keys';

export const useCreateEciIntegration: MutationFunction<unknown, any> = ({
  query,
  requestOptions,
  queryOptions,
} = {}) => {
  const queryClient = useQueryClient();
  const request = useRequest(requestOptions);

  return useMutation(
    (body) => {
      return request(`/managed_integrations/eci_setup/`, {
        query,
        init: { method: 'POST', body },
      });
    },
    {
      ...queryOptions,
      mutationKey: ['createEciIntegration'],
      onSuccess: (data, requestData, ...rest) => {
        queryClient.invalidateQueries({
          queryKey: getManagedIntegrationListKey(),
        });
        queryOptions?.onSuccess?.(data, requestData, ...rest);
      },
    },
  );
};

export default {
  useCreateEciIntegration,
};
